import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { seoRouteForPath, siteName, siteOrigin } from "../seo";

function setMeta(selector: string, attribute: "name" | "property", key: string, content: string) {
  let element = document.head.querySelector<HTMLMetaElement>(selector);
  if (!element) {
    element = document.createElement("meta");
    element.setAttribute(attribute, key);
    document.head.append(element);
  }
  element.content = content;
}

export function RouteSeo() {
  const { pathname } = useLocation();

  useEffect(() => {
    const route = seoRouteForPath(pathname);
    const canonicalPath = route?.canonicalPath ?? route?.path ?? pathname;
    const canonical = new URL(canonicalPath, siteOrigin).href;
    const title = route?.title ?? `Page not found — ${siteName}`;
    const description = route?.description ?? "This path does not lead anywhere on Forge Island.";
    const image = new URL(route?.image ?? "/art/brand/grinning-forge-emblem.webp", siteOrigin).href;
    const robots = route?.index ? "index,follow" : "noindex,nofollow";

    document.title = title;
    setMeta('meta[name="description"]', "name", "description", description);
    setMeta('meta[name="robots"]', "name", "robots", robots);
    setMeta('meta[property="og:type"]', "property", "og:type", "website");
    setMeta('meta[property="og:site_name"]', "property", "og:site_name", siteName);
    setMeta('meta[property="og:title"]', "property", "og:title", title);
    setMeta('meta[property="og:description"]', "property", "og:description", description);
    setMeta('meta[property="og:url"]', "property", "og:url", canonical);
    setMeta('meta[property="og:image"]', "property", "og:image", image);
    setMeta('meta[name="twitter:card"]', "name", "twitter:card", "summary_large_image");
    setMeta('meta[name="twitter:title"]', "name", "twitter:title", title);
    setMeta('meta[name="twitter:description"]', "name", "twitter:description", description);
    setMeta('meta[name="twitter:image"]', "name", "twitter:image", image);

    let canonicalLink = document.head.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonicalLink) {
      canonicalLink = document.createElement("link");
      canonicalLink.rel = "canonical";
      document.head.append(canonicalLink);
    }
    canonicalLink.href = canonical;
  }, [pathname]);

  return null;
}
